import StoreModuleService from '../../../StoreModuleService';
import { MODULE_NAME } from './const';
import state from './state';
import { isNullOrUndefined } from '@/utils/helpers';
import api from '@/api';
import { SET_WORKFLOW_VERSION_DATA, REMOVE_WORKFLOW_VERSION_DATA, SET_SELECTED_WORKFLOW_VERSION_ID } from './mutations';
import { getWorkflowVersion } from './getters';
import isObject from 'lodash/isObject';
import { getConfiguration, setConfigurationData } from '../../../workflowConfigurations/actions';
import { clearVersionFromWorkflow, updateVersionOfWorkflow } from '@/store/modules/workflows/actions.js';
import { getWorkflowVersionGraph } from '@/store/modules/workflows/actions';
const buildWorkflowVersionActionObject = (action) => StoreModuleService.buildActionObject(MODULE_NAME, action);
// actions declarations
export const getVersionOfWorkflow = buildWorkflowVersionActionObject('getVersionOfWorkflow');
export const fetchVersionOfWorkflow = buildWorkflowVersionActionObject('fetchVersionOfWorkflow');
export const setVersionOfWorkflow = buildWorkflowVersionActionObject('setVersionOfWorkflow');
export const removeWorkflowVersion = buildWorkflowVersionActionObject('removeWorkflowVersion');
export const updateWorkflowVersion = buildWorkflowVersionActionObject('updateWorkflowVersion');
export const selectWorkflowVersionId = buildWorkflowVersionActionObject('selectWorkflowVersionId');
export const clearSelectedWorkflowSelectedVersion = buildWorkflowVersionActionObject('clearSelectedWorkflowSelectedVersion');

const actions = {
	...StoreModuleService.createDefaultActions(),
	async [getVersionOfWorkflow.action]({ dispatch, getters }, payload) {
		const { workflowId, workflowVersionId, forceGet } = payload;
		const dataIsMissing = isNullOrUndefined(state.data[workflowVersionId]);
		const needToGet = dataIsMissing || forceGet;
		if (needToGet) {
			await dispatch(fetchVersionOfWorkflow.action, { workflowVersionId, workflowId });
		}
		return getters[getWorkflowVersion.getter](workflowVersionId);
	},
	async [fetchVersionOfWorkflow.action]({ dispatch }, { workflowId, workflowVersionId }) {
		const workflowVersion = await api.getWorkflowVersion(workflowId, workflowVersionId);
		await dispatch(getWorkflowVersionGraph.fullPath, { workflowId, workflowVersionId }, { root: true });

		await dispatch(setVersionOfWorkflow.action, { data: workflowVersion });
	},
	async [removeWorkflowVersion.action]({ commit, dispatch }, { workflowId, workflowVersionId }) {
		await api.removeWorkflowVersion(workflowId, workflowVersionId);
		commit(REMOVE_WORKFLOW_VERSION_DATA, { versionId: workflowVersionId });
		dispatch(clearVersionFromWorkflow.fullPath, { workflowId, workflowVersionId }, { root: true });
	},
	async [selectWorkflowVersionId.action]({ commit }, { selectedWorkflowVersionId }) {
		return commit(SET_SELECTED_WORKFLOW_VERSION_ID, { selectedWorkflowVersionId });
	},
	async [clearSelectedWorkflowSelectedVersion.action]({ dispatch }) {
		return dispatch(selectWorkflowVersionId.action, { selectedWorkflowVersionId: null });
	},

	async [updateWorkflowVersion.action]({ commit, dispatch }, { workflowId, workflowVersionId, partialVersionObject }) {
		const workflowVersion = await api.updateWorkflowVersion(workflowId, workflowVersionId, partialVersionObject);
		commit(SET_WORKFLOW_VERSION_DATA, { key: workflowVersion.id, value: workflowVersion });
		dispatch(updateVersionOfWorkflow.fullPath, { workflowId, workflowVersion }, { root: true });
	},
	async [setVersionOfWorkflow.action]({ commit, dispatch }, payload) {
		const { data: workflowVersion } = payload;
		if (workflowVersion.general_config_options) {
			if (isObject(workflowVersion.general_config_options)) {
				await dispatch(setConfigurationData.fullPath, { data: workflowVersion.general_config_options }, { root: true });
			} else {
				await dispatch(getConfiguration.fullPath, { id: workflowVersion.general_config_options, forceGet: true }, { root: true });
			}
		}
		if (workflowVersion.user_specific_config_options) {
			if (isObject(workflowVersion.user_specific_config_options)) {
				await dispatch(setConfigurationData.fullPath, { data: workflowVersion.user_specific_config_options }, { root: true });
			} else {
				await dispatch(getConfiguration.fullPath, { id: workflowVersion.user_specific_config_options, forceGet: true }, { root: true });
			}
		}
		commit(SET_WORKFLOW_VERSION_DATA, { key: workflowVersion.id, value: workflowVersion });
	},
};

export default actions;
